import { mode } from '@chakra-ui/theme-tools';

export const dividerStyles = {
  components: {
    Divider: {
      baseStyle: (props) => ({
        opacity: 1,
        borderColor:  mode('gray.100', '#050B21')(props),
        borderBottomWidth: '4px',
      }),
      variants: {
        'active': (props) => ({
          borderColor: '#099BFF',
          borderStyle: 'solid',
        }),
      },
    }
  },
};
